import color from "../../assets/jss/color";
import {
  primaryColor,
  primaryBoxShadow,
  whiteColor,
  blackColor,
  grayColor,
  hexToRgb,
} from "../../assets/jss/material-dashboard-pro-react.jsx";

const styles = (theme) => ({
  title: {
    paddingLeft: "5px",
    marginBottom: "12px !important",
    maxWidth: "100%",
    textTransform: "uppercase",
    textAlign: "left",
    color: "rgb(9, 64, 102)",
  },
  easyButtonStl: {
    paddingLeft: "16px",
  },
  validationSummary: {
    backgroundColor: "#fff5f5",
    border: "1px solid #df3f4a",
    borderRadius: "8px",
    boxSizing: "border-box",
    color: "#8a1f28",
    margin: "0 0 16px",
    padding: "14px 16px",
    textTransform: "none",
    width: "100%",
  },
  validationSummaryTitle: {
    color: "#8a1f28",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: 1.35,
    margin: "0 0 8px",
    textTransform: "none",
  },
  validationSummaryList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px 14px",
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  validationSummaryLink: {
    background: "transparent",
    border: 0,
    color: "#8a1f28",
    cursor: "pointer",
    font: "inherit",
    fontSize: "13px",
    fontWeight: 700,
    padding: 0,
    textDecoration: "underline",
    textTransform: "none",
  },
  validationChoiceError: {
    border: "1px solid #df3f4a",
    borderRadius: "8px",
    boxSizing: "border-box",
    padding: "10px 12px",
  },
  validationInlineMessage: {
    color: "red",
    display: "flex",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: "10px",
    justifyContent: "flex-end",
    lineHeight: "14px",
    marginTop: "6px",
    textTransform: "uppercase",
  },
  fab: {
    marginTop: "20px",
    marginBottom: "20px",
  },
  legallandlabel: {
    fontWeight: "bold",
    textAlign: "left",
    color: "rgb(9, 64, 102)",
  },
  serviceareaname: {
    textAlign: "left",
  },
  andor: {
    color: color.mcsred,
    textAlign: "center",
  },
  sectiontitle: {
    color: color.mcsdarkblue,
    fontWeight: "bold",
    textAlign: "center",
  },
  promocode: {
    position: "relative",
    top: "-10px",
  },
  godown: {
    position: "relative",
    top: "20px",
  },
  recaptchabox: {
    marginLeft: "5px",
    marginRight: "5px",
  },
  recaptcha: {
    borderRadius: "20px",
    display: "flex",
    marginTop: "20px",
    marginBottom: "20px",
    justifyContent: "flex-end",
  },
  select: {
    padding: "12px 0 7px",
    fontSize: ".75rem",
    fontWeight: "400",
    lineHeight: "1.42857",
    textDecoration: "none",
    textTransform: "uppercase",
    color: grayColor[2],
    letterSpacing: "0",
    "&:focus": {
      backgroundColor: "transparent",
    },
    "&[aria-owns] + input + svg": {
      transform: "rotate(180deg)",
    },
    "& + input + svg": {
      transition: "all 300ms linear",
    },
  },
  selectFormControl: {
    // was: margin: "7px 0 17px 0 !important",
    margin: "8px 0 17px 0 !important", // ⬅️ matches your text input rhythm
    "& > div": {
      "&:before": {
        borderBottomWidth: "1px !important",
        borderBottomColor: grayColor[4] + " !important",
      },
      "&:after": {
        borderBottomColor: primaryColor[0] + " !important",
      },
    },
  },
  selectLabel: {
    fontSize: "12px",
    textTransform: "uppercase",
    color: grayColor[2] + " !important",
    top: "8px",
  },
  selectMenu: {
    "& > div > ul": {
      border: "0",
      padding: "5px 0",
      margin: "0",
      boxShadow: "none",
      minWidth: "100%",
      borderRadius: "4px",
      boxSizing: "border-box",
      display: "block",
      fontSize: "14px",
      textAlign: "left",
      listStyle: "none",
      backgroundColor: whiteColor,
      backgroundClip: "padding-box",
    },
    "& $selectPaper $selectMenuItemSelectedMultiple": {
      backgroundColor: "inherit",
    },
    "& > div + div": {
      maxHeight: "266px !important",
    },
  },
  selectMenuItem: {
    fontSize: "13px",
    padding: "10px 20px",
    margin: "0 5px",
    borderRadius: "2px",
    transition: "all 150ms linear",
    display: "block",
    clear: "both",
    fontWeight: "400",
    lineHeight: "2",
    whiteSpace: "nowrap",
    color: grayColor[7],
    paddingRight: "30px",
    "&:hover": {
      backgroundColor: primaryColor[0],
      color: whiteColor,
      ...primaryBoxShadow,
    },
  },
  selectMenuItemSelected: {
    backgroundColor: primaryColor[0] + "!important",
    color: whiteColor,
  },

  selectMenuItemSelectedMultiple: {
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: primaryColor[0] + "!important",
      color: whiteColor,
      ...primaryBoxShadow,
      "&:after": {
        color: whiteColor,
      },
    },
    "&:after": {
      top: "16px",
      right: "12px",
      width: "12px",
      height: "5px",
      borderLeft: "2px solid currentColor",
      transform: "rotate(-45deg)",
      opacity: "1",
      color: grayColor[2],
      position: "absolute",
      content: "''",
      borderBottom: "2px solid currentColor",
      transition: "opacity 90ms cubic-bezier(0,0,.2,.1)",
    },
  },
  selectPaper: {
    boxSizing: "borderBox",
    borderRadius: "4px",
    padding: "0",
    minWidth: "100%",
    display: "block",
    border: "0",
    boxShadow: "0 2px 5px 0 rgba(" + hexToRgb(blackColor) + ", 0.26)",
    backgroundClip: "padding-box",
    margin: "2px 0 0",
    fontSize: "14px",
    textAlign: "left",
    listStyle: "none",
    backgroundColor: "transparent",
    maxHeight: "266px",
  },
  submit: {
    background: color.mcslightblue,
    "&:hover": {
      backgroundColor: color.mcslightblue,
    },
    color: "white",
    marginTop: "20px",
    "text-shadow": "1px 1px 1px grey",
  },
  checkRoot: {
    padding: "14px",
  },
  checked: {
    color: primaryColor[0] + "!important",
  },
  checkedIcon: {
    width: "20px",
    height: "20px",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    borderRadius: "3px",
  },
  uncheckedIcon: {
    width: "0px",
    height: "0px",
    padding: "9px",
    border: "1px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    borderRadius: "3px",
  },
  label: {
    cursor: "pointer",
    paddingLeft: "0",
    color: grayColor[3],
    fontSize: "14px",
    lineHeight: "1.428571429",
    fontWeight: "400",
    display: "inline-flex",
    transition: "0.3s ease all",
  },
  errorMessage: {
    color: "red",
  },
  addPhoneDiv: {
    paddingLeft: "5px",
  },
  addPhoneBtn: {
    backgroundColor: "white",
    boxShadow: "none",
    border: "1px solid blue",
    color: "rgb(9, 64, 102)",
    borderRadius: "8px",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "rgb(9, 64, 102)",
      color: "white",
    },
  },
  selectStyles: {
    border: "1px solid #ced4da",
    boxShadow: "0 3px 6px 0 grey",
  },
  mainDiv: {
    width: "75%",
    "@media (max-width: 420px)": {
      width: "90%",
    },
  },
  cardPadding: {
    padding: "20px 35px",
    "@media (max-width: 420px)": {
      padding: "20px 5px",
    },
  },
  landDesc: {
    "@media (max-width: 420px)": {
      paddingLeft: "0",
    },
  },
  mobilePadding: {
    "@media (max-width: 420px)": {
      padding: "0 10px",
    },
  },
  mainDivStyles: {
    paddingLeft: "15px",
  },
  titleStyles: {
    color: "#094066",
    marginBottom: "40px",
    fontWeight: "bold",
    textAlign: "left",
  },
  txtColor: {
    color: "#094066",
    marginBottom: "5px",
  },
  inputStyles: {
    width: "100%",
  },
  typography: {
    textTransform: "uppercase",
    textAlign: "left",
    color: "rgb(9, 64, 102)",
    marginBottom: "15px",
  },
  serviceAreaDiv: {
    backgroundColor: "#f0f0f0",
    borderRadius: "5px",
    padding: "1px 13px",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    marginBottom: "15px",
  },
  serviceAreaTitle: {
    color: "rgb(9, 64, 102)",
    marginBottom: "15px",
    fontWeight: "bold",
  },
  inputTitle: {
    margin: "12px 0 6px !important",
    textTransform: "uppercase",
    textAlign: "left",
    color: "rgb(9, 64, 102)",
    marginBottom: "-13px",
  },
  promoCodeText: {
    justifyContent: "left",
    maxWidth: "100%",
  },
  submitBtn: {
    backgroundColor: "#df3f4a",
    borderRadius: "5px",
    width: "50%",
    fontWeight: "bold",
    marginLeft: "15px",
  },
  clearFormText: {
    marginRight: "15px",
    color: "blue",
    textDecoration: "underline",
    display: "inline-block",
    "&:hover": {
      cursor: "pointer",
    },
  },
  noUnderline: {
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none !important",
    },
  },
  searchField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    "& .MuiInputLabel-outlined": {
      color: "#094066", // default label color
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "#094066", // focused label color
    },
    // optional: when it's shrunk (has value)
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      color: "#094066", // or another color if you want
    },

    "& .MuiOutlinedInput-root": {
      borderRadius: 15, // change this for more/less roundness

      "& fieldset": {
        borderColor: "#094066", // default border color
      },
      "&:hover fieldset": {
        borderColor: "#094066", // hover color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#094066", // focused color
        borderWidth: 2, // optional: thicker on focus
      },
    },
  },
});
export default styles;
